//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { LanguageDisplayItem } from './LanguageDisplayItem';

export class TeacherContactDisplayItem extends ItemBase {
    ID: string | null = null;
    Address: string | null = null;
    AllowPracticeLogEmail: boolean = false;
    EmailAddress: string | null = null;
    FirstName: string | null = null;
    FullName: string | null = null;
    IsActive: boolean = false;
    IsAdministrator: boolean = false;
    IsTeacher: boolean = false;
    LastName: string | null = null;
    HasProfilePicture: boolean = false;
    ProfileThumbnailURL: string | null = null;
    ProfileHeadshotURL: string | null = null;
    ProfilePictureURL: string | null = null;
    Subjects: string[] = [];     // OBSOLETE - Use only for compatibility
    SpokenLanguages: LanguageDisplayItem[] = [];
    Telephone: string | null = null;
    BiographyBody: string | null = null;

    constructor(initializer?: Partial<TeacherContactDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherContactDisplayItem";
}
